export default __webpack_public_path__ + "static/media/Background.48d2d916.jpg";